import Entity from "./Entity";

export default class Application {

    public static deserialize(input: any): Application {
        return new Application(input.id, input.name, input.status.toUpperCase(), input.entities.map(Entity.deserialize));
    }
    public readonly id: string;
    public readonly name: string;
    public readonly status: ApplicationStatus;
    public readonly entities: Entity[];

    /* tslint:disable-next-line:variable-name */
    public readonly __typename: string = "Application";

    constructor(id: string, name: string, status: ApplicationStatus, entities: Entity[]) {
        this.id = id;
        this.name = name;
        this.entities = entities;
        this.status = status;
    }
    
}

export enum ApplicationStatus {
    Draft = "DRAFT",
    Provisioning = "PROVISIONING",
    Enabled = "ENABLED",
    Disabled = "DISABLED"
}


// WEBPACK FOOTER //
// ./src/metamodel/Application.ts